/**
 * Formats decimal hours (e.g. 1.5) into a compact "Xh Ym" label.
 * Used for time-entry durations and estimated/tracked displays.
 *
 * @example
 * formatTrackedHours(1.5)  // "1h 30m"
 * formatTrackedHours(0.41) // "25m"
 * formatTrackedHours(0)    // "0m"
 */
export function formatTrackedHours(hours: number | null | undefined): string {
  const safe = typeof hours === 'number' && Number.isFinite(hours) ? hours : 0;
  const totalMinutes = Math.round(safe * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  if (h > 0 && m > 0) return `${h}h ${m}m`;
  if (h > 0) return `${h}h`;
  return `${m}m`;
}
